import { useContext } from 'react';

import { flexRender } from '@tanstack/react-table';
import clsx from 'clsx';

// Types
import { CompoundTableContext } from '@/components/base/Table/CompoundTable';

function TableBody() {
    const { table, columnIdHover } = useContext(CompoundTableContext);
    const stickyRowClassName =
        table.options.meta?.stickyRow?.className ?? 'sticky top-14 z-2 shadow-icoXS';
    const nbRows = table.getRowModel().rows.length;
    return (
        <tbody>
            {table.getRowModel().rows.map((row, rowIndex) => {
                return (
                    <tr
                        key={row.id}
                        className={clsx({
                            [stickyRowClassName]: table.options.meta?.stickyRow?.isSticky(row)
                        })}>
                        {row.getVisibleCells().map((cell, cellIndex) => {
                            const nbColumns = table.getAllLeafColumns().length;
                            const isColumnHovered = columnIdHover === cellIndex;
                            return (
                                <td
                                    key={cell.id}
                                    className={clsx(
                                        'relative h-14 border-icoGray-300 bg-white p-0 dark:border-icoDarkMode-beton dark:bg-icoDarkMode-anthracite',
                                        {
                                            'border-r': cellIndex < nbColumns - 1,
                                            'border-b': rowIndex < nbRows - 1,
                                            'sticky left-0 z-1':
                                                cell.column.columnDef.meta?.isSticky
                                        }
                                    )}>
                                    {isColumnHovered ? (
                                        <span className="absolute inset-0 bg-icoBlue bg-opacity-[0.02]" />
                                    ) : null}
                                    <span
                                        data-testid={`row-${rowIndex}-cell-${cellIndex}`}
                                        className="flex h-full w-full items-center justify-center">
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </span>
                                </td>
                            );
                        })}
                    </tr>
                );
            })}
        </tbody>
    );
}

export default TableBody;
